import axios from 'axios';
import config from '../../../../config/index';
import { token } from '../../../login/duck/actions/login';

import { SET_DETAILS_LICENSES, SET_DETAILS_ERROR_LICENSES } from '../types';

const setLicenseDetaiils = data => ({
  type: SET_DETAILS_LICENSES,
  payload: data,
});

const errorFetchingLicenses = error => ({
  type: SET_DETAILS_ERROR_LICENSES,
  error,
});

const fetchLicenseDetails = bundleID => dispatch => axios.get(`${config.host}/bundles/${bundleID}`, { headers: { Authorization: `Bearer ${token()}` } })
  .then(({ data }) => { dispatch(setLicenseDetaiils(data)); })
  .catch((error) => { dispatch(errorFetchingLicenses(error)); });

export default fetchLicenseDetails;
